module.exports = __webpack_public_path__ + "static/media/product-small-03.ac3ce0ea.png";